import {Spinner} from "@fluentui/react-components";
import * as React from "react";

export default function ProgressSpinner(props:{ title: string }) {
  return <div className="ms-welcome">
    <Spinner label={props.title}/>
  </div>
}